/* istanbul ignore file */
export function isVisible(elem) {
  const style = getComputedStyle(elem);

  if (style.display === 'none') return false;
  if (style.visibility !== 'visible') return false;
  if (style.opacity === 0) return false;

  if (
    elem.offsetWidth +
      elem.offsetHeight +
      elem.getBoundingClientRect().height +
      elem.getBoundingClientRect().width ===
    0
  )
    return false;

  const elementPoints = {
    center: {
      x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
      y: elem.getBoundingClientRect().top + elem.offsetHeight / 2,
    },
    topLeft: {
      x: elem.getBoundingClientRect().left,
      y: elem.getBoundingClientRect().top,
    },
    topRight: {
      x: elem.getBoundingClientRect().right,
      y: elem.getBoundingClientRect().top,
    },
    bottomLeft: {
      x: elem.getBoundingClientRect().left,
      y: elem.getBoundingClientRect().bottom,
    },
    bottomRight: {
      x: elem.getBoundingClientRect().right,
      y: elem.getBoundingClientRect().bottom,
    },
  };

  const docWidth = document.documentElement.clientWidth || window.innerWidth;
  const docHeight = document.documentElement.clientHeight || window.innerHeight;

  // lets make sure some percentage is visible to count it as really visible
  const visiblePercent = 0.5;
  const mostlyVisibleWidth = visiblePercent * elem.getBoundingClientRect().width;
  const mostlyVisibleHeight = visiblePercent * elem.getBoundingClientRect().height;

  if (
    elementPoints.topLeft.x > docWidth - mostlyVisibleWidth ||
    elementPoints.topLeft.y > docHeight - mostlyVisibleHeight ||
    elementPoints.bottomRight.x < mostlyVisibleWidth ||
    elementPoints.bottomRight.y < mostlyVisibleHeight
  )
    return false;

  for (let index in elementPoints) {
    const point = elementPoints[index];
    let pointContainer = document.elementFromPoint(point.x, point.y);
    if (pointContainer !== null) {
      do {
        if (pointContainer === elem) return true;
        pointContainer = pointContainer.parentNode;
      } while (pointContainer);
    }
  }
  return false;
}
